import _ from 'lodash'
import { actions } from '@adc/ui-morpheus'
import { startSubmit, stopSubmit, submit } from 'redux-form'
import {
  getEvents,
  bulkUpdateEvent,
  getEventAggregations,
} from '../providers/events'
import { searchUsers } from '../providers/users'
import { savedSearchProviders } from '../providers/savedSearches'
import {
  CLEAR_EVENTS,
  UPDATE_EVENT_IN_LIST,
  STORE_PARENT_EVENT,
  CLEAR_PARENT_EVENT,
  UPDATE_BULK_UPDATED_EVENT_COUNT,
  CLEAR_BULK_UPDATED_EVENT_COUNT,
} from '../constants/actionTypes'
import { EVENTS } from '../constants/tableTypes'
import { tableConfig } from '../reducers/events/columnDefinitions'
import { FORM_EVENT_BULK_UPDATE } from '../constants/formNames'
import { uiToApiBulkFields } from '../translations/events'
import { POST_BULK_UPDATE_DELAY } from '../constants/statics'
import { timeout } from '../util/common'

const getGridEvents = (req, fetchOptions) => {
  const fields = [
    'event_id',
    ...tableConfig.fieldDefinitions
      .filter(fieldDefinition => !fieldDefinition.isUiOnly)
      .map(field => field.apiRef),
  ]

  return getEvents(req, {
    ...fetchOptions,
    fields,
  })
}

export const {
  fetchTable,
  fetchTableAppend,
  addFilter,
  fetchTableBatches,
  clearFilters,
  changeSortBy,
  removeFilter,
  savedSearchActions,
} = actions.dataTable.initDataTable(EVENTS, {
  getTableValues: getGridEvents,
  getAggregations: getEventAggregations,
  getUsers: searchUsers,
  ...savedSearchProviders,
})

export const clearEvents = () => ({
  type: CLEAR_EVENTS,
})

export const { abortTableValues, resetTableValues } = actions.dataTable

export const updateEventInList = event => ({
  type: UPDATE_EVENT_IN_LIST,
  event,
})

export const storeParentEvent = event => ({
  type: STORE_PARENT_EVENT,
  event,
})

export const clearParentEvent = event => ({
  type: CLEAR_PARENT_EVENT,
})

export const updateBulkUpdatedEventCount = (eventsUpdated, eventCount) => ({
  type: UPDATE_BULK_UPDATED_EVENT_COUNT,
  eventsUpdated,
  eventCount,
})

export const clearBulkUpdatedEventCount = () => ({
  type: CLEAR_BULK_UPDATED_EVENT_COUNT,
})

export const bulkUpdateEvents = (
  eventIds,
  postUpdateDelay = POST_BULK_UPDATE_DELAY
) => {
  return async (dispatch, getState) => {
    const formValues = _.get(
      getState(),
      `form.${FORM_EVENT_BULK_UPDATE}.values`
    )

    // Submit via redux-form to force any validation errors first
    dispatch(submit(FORM_EVENT_BULK_UPDATE))
    // Turn spinner back on while bulk updating since form submission stops spinner animation
    dispatch(startSubmit(FORM_EVENT_BULK_UPDATE))

    // Split into arrays of 100 event ids
    const batches = _.chunk(eventIds, 100)

    const promises = await Promise.all(
      batches.map(async batch => {
        try {
          // to show some progress in the beginning
          dispatch(
            updateBulkUpdatedEventCount(
              Math.floor(batch.length / 2),
              eventIds.length
            )
          )
          const response = await bulkUpdateEvent(null, {
            event_ids: batch,
            update: { ...uiToApiBulkFields(formValues) },
          })
          // show other "half" of progress being completed
          dispatch(
            updateBulkUpdatedEventCount(
              Math.ceil(response.success.length / 2),
              eventIds.length
            )
          )
          await timeout(postUpdateDelay)
          return response
        } catch (error) {
          dispatch(stopSubmit(FORM_EVENT_BULK_UPDATE))
          return error
        }
      })
    )

    dispatch(stopSubmit(FORM_EVENT_BULK_UPDATE))
    dispatch(clearBulkUpdatedEventCount())

    const customizer = (objValue, srcValue) => {
      if (_.isArray(objValue)) {
        return objValue.concat(srcValue)
      }
    }

    const promiseResponse = _.mergeWith(...promises, customizer)

    return promiseResponse
  }
}
